import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { FiCheck } from 'react-icons/fi';

const ShareIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

const ShareButton = ({ className }) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const handleShare = async () => {
    const url = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Collins Musoko — Full-Stack Software Engineer',
          text: 'Check out the portfolio of Collins Musoko, Full-Stack Software Engineer.',
          url,
        });
      } catch {
        // User cancelled the share sheet
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard unavailable (e.g. insecure context)
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      aria-label={copied ? 'Link copied' : 'Share'}
      title={copied ? 'Link copied' : 'Share'}
      className={`relative ${className}`}
    >
      {copied ? <FiCheck className="h-[18px] w-[18px] text-emerald-300" /> : <ShareIcon />}
    </button>
  );
};

ShareButton.propTypes = {
  className: PropTypes.string,
};

ShareButton.defaultProps = {
  className: '',
};

export default ShareButton;
